import {MenuItem, Stack, TextField} from "@mui/material";
import type {NumericResolver} from "../../../../../../sdo/Resolver.ts";
import {NUMERIC_MARKERS, NUMERIC_MARKER_CATEGORIES} from "../../../../../../sdo/NumericMarker.ts";
import {MatchModeRow, F, Sw, SummaryPill, SummaryPillRow, rowSx, fieldSx, selectSx, set, setNum, type ResolverEditorProps} from "./ResolverUtils.tsx";

function NumericEditor({draft, editing, onChange}: ResolverEditorProps & { draft: NumericResolver }) {
    if (!editing) {
        return (
            <Stack direction="column" spacing={0.5} sx={{alignItems: "center", width: "100%"}}>
                <SummaryPillRow>
                    <SummaryPill label="Value" value={draft.value}/>
                    <SummaryPill label="Precision" value={draft.precision}/>
                </SummaryPillRow>
                <SummaryPillRow>
                    <SummaryPill label="Enforce Type" value={draft.enforceType ? "Yes" : "No"}/>
                    {draft.enforceType && <SummaryPill label="Numeric Type" value={NUMERIC_MARKERS.find(m => m.key === draft.numericType)?.display ?? draft.numericType}/>}
                </SummaryPillRow>
            </Stack>
        );
    }

    const upd = (key: string, value: unknown) => set(draft, key, value, onChange);
    const updNum = (key: string, raw: string) => setNum(draft, key, raw, onChange);

    return (
        <Stack direction="column" spacing={1} alignItems="center">
            <MatchModeRow draft={draft} editing={editing} onChange={onChange}/>
            <Stack direction="row" sx={rowSx}>
                <F value={draft.value} placeholder="Numeric Value" onChange={(v) => updNum("value", v)} width="180px"/>
                <TextField
                    size="small" type="number" value={draft.precision} label="Precision"
                    onChange={(e) => updNum("precision", e.target.value)}
                    sx={{...fieldSx, width: "100px"}}
                    inputProps={{min: 0, max: 10}}
                />
                <Sw checked={draft.enforceType} label="Match Numeric Type" onChange={(v) => upd("enforceType", v)}/>
            </Stack>
            {draft.enforceType && (
                <Stack direction="row" sx={rowSx}>
                    <TextField
                        size="small" select value={draft.numericType} label="Numeric Type"
                        onChange={(e) => upd("numericType", e.target.value)}
                        sx={{...selectSx, minWidth: "220px"}}
                    >
                        {NUMERIC_MARKER_CATEGORIES.map((cat) => {
                            const items = NUMERIC_MARKERS.filter(m => m.category === cat);
                            if (items.length === 0) return null;
                            return [
                                <MenuItem key={`hdr-${cat}`} disabled sx={{
                                    fontSize: "0.65rem",
                                    color: "#02cfee",
                                    fontWeight: 700,
                                    opacity: "1 !important",
                                    paddingY: "2px",
                                }}>
                                    {cat}
                                </MenuItem>,
                                ...items.map((m) => (
                                    <MenuItem key={m.key} value={m.key} sx={{fontSize: "0.75rem", paddingLeft: "24px"}}>
                                        {m.display}
                                    </MenuItem>
                                )),
                            ];
                        })}
                    </TextField>
                </Stack>
            )}
        </Stack>
    );
}

export default NumericEditor;
